export default "__VITE_ASSET__C8fZaxCM__"